import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  transactionContainer: {
    height: 'calc(100vh - 136px)',
    overflow: 'auto',
  },
  mainHeader: {},
  mainHeaderText: {
    fontSize: 29,
    color: theme.palette.warning.contrastText,
    marginBottom: 30,
    fontWeight: 700,
    letterSpacing: 0.3,
    '@media (max-width: 525px)': {
      fontSize: 20,
    },
  },
  traxTableBox: {
    height: 'calc(100% - 74px)',
    background: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[1],
    borderRadius: 20,
  },
  traxTable: {
    padding: 30,
    height: 'calc(100% - 60px)',
  },
  traxHBox: {
    display: 'flex',
    marginBottom: 32,
  },
  searchBox: {
    position: 'relative',
    border: '1px solid #C4C4C4',
    width: 257,
    borderRadius: 30,
  },
  inputSear: {
    width: 'calc(100% - 42px)',
    paddingLeft: 14,
  },
  iconButton: {
    padding: 10,
  },
  filterControl: {
    display: 'flex',
    alignSelf: 'center',
    justifyContent: 'flex-end',
    // width: 'calc(100% - 257px)',
    width: '100%',
  },
  formLabel: {
    width: 60,
    fontSize: 14,
    color: theme.palette.grey[300],
    alignSelf: 'center',
  },
  selectBox: {
    width: 136,
    height: 36,
    border: '1px solid #CED4DA',
    borderRadius: 5,
    '& .MuiSelect-select.MuiSelect-select': {
      paddingLeft: 10,
    },
    '&::before': {
      borderBottom: 0,
    },
    '& ::hover': {
      '& :not(.Mui-disabled):before': {
        borderBottom: 0,
      },
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 0,
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 10px)',
      right: 8,
    },
  },
  tableContainer: {
    maxHeight: 'calc(100% - 75px)',
    overflow: 'overlay',
  },
  stikyTable: {},
  tableHead: {},
  tableRow: {
    backgroundColor: 'transparent !important',
  },
  remarkText: {
    color: theme.palette.grey[400],
    fontSize: 13,
    fontStyle: 'italic',
  },
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
  },
  noRecordText: {
    color: theme.palette.grey[600],
    fontSize: 15,
    letterSpacing: 0.3,
    textAlign: 'center',
  },
}));
